import { LaneSearchDetails } from '../dtos/lane-search-details';
import { AdminLaneSearchDetails } from '../views/admin-lane-search-details';

export const ADMIN_LANE_SEARCH_DETAILS__TABLE = (
	laneSearches: Array<LaneSearchDetails> = []
): Array<AdminLaneSearchDetails> => {
	let results: Array<AdminLaneSearchDetails> = [];
	if (laneSearches.length > 0) {
		laneSearches.map((search) => {
			let row = {} as AdminLaneSearchDetails;
			row.businessName = search.businessName;
			row.origin = search.originCity + ' ' + search.originState;
			row.originDeadhead = search.originDeadhead;
			row.destination = search.destCity + ' ' + search.destState;
			row.postedOn = search.created;
			results.push(row);
		});
		return results;
	}
};
